import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Menu, MenuItem, ButtonBase, Typography } from "@mui/material";
import { FR, DZ, GB } from "country-flag-icons/react/3x2";
import { mdiChevronDown } from "@mdi/js";
import Icon from "@mdi/react";

const LANGUAGES = [
	{ code: "fr", label: "Français", Flag: FR },
	{ code: "ar", label: "العربية", Flag: DZ },
	{ code: "en", label: "English", Flag: GB },
];
export function LanguageSwitcher({ variant = "login" }) {
	const { i18n } = useTranslation();
	const current = LANGUAGES.find(l => l.code === i18n.language?.slice(0, 2)) ?? LANGUAGES[0];
	const [anchor, setAnchor] = useState(null);

	const handleSelect = (code) => {
		setAnchor(null);
		if (code === current.code) return;
		i18n.changeLanguage(code);
		document.documentElement.lang = code;
		// document.documentElement.dir = code === "ar" ? "rtl" : "ltr";
		window.location.reload();
	};

	const renderTrigger = () => {
		if (variant === "header") {
			return (
				<ButtonBase onClick={(e) => setAnchor(e.currentTarget)} sx={{ mr: 1 }}>
					<current.Flag style={{ width: 40, height: 40, borderRadius: 3 }} />
				</ButtonBase>
			);
		}

		if (variant === "login") {
			return (
				<ButtonBase
					onClick={(e) => setAnchor(e.currentTarget)}
					sx={{
						display: "flex", alignItems: "center", gap: 0.75,
						px: 1.25, py: 1,
						borderRadius: "8px",
						bgcolor: "background.paper",
					}}
				>
					<current.Flag style={{ width: 20, borderRadius: 3 }} />
					<Typography variant="caption" fontWeight={600} sx={{ fontSize: "0.78rem", lineHeight: 1 }}>
						{current.code.toUpperCase()}
					</Typography>
					<Icon path={mdiChevronDown} size="14px" style={{ opacity: 0.5, marginLeft: 1 }} />
				</ButtonBase>
			);
		}

		if (variant === "menu") {
			return (
				<ButtonBase
					onClick={(e) => setAnchor(e.currentTarget)}
					sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}
				>
					<Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
						<current.Flag style={{ width: "22px", borderRadius: 3 }} />
						<Typography variant="body2">
							{current.code.toUpperCase()}
						</Typography>
					</Box>
					<Box>
						<Icon path={mdiChevronDown} size="14px" style={{ opacity: 0.5, marginLeft: 1 }} />

					</Box>
				</ButtonBase>
			);
		}
	};

	return (
		<>
			{renderTrigger()}

			<Menu
				anchorEl={anchor}
				open={Boolean(anchor)}
				onClose={() => setAnchor(null)}
				PaperProps={{
					sx: { borderRadius: "10px", minWidth: 150, mt: 0.5, boxShadow: "0 4px 20px rgba(0,0,0,0.12)" },
				}}
				transformOrigin={{ horizontal: "right", vertical: "top" }}
				anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
			>
				{LANGUAGES.map(({ code, label, Flag }) => (
					<MenuItem
						key={code}
						selected={code === current.code}
						onClick={() => handleSelect(code)}
						sx={{
							gap: 1.25, borderRadius: "7px", mx: 0.5, px: 1.25,
							"&.Mui-selected": { bgcolor: "action.selected", fontWeight: 600 },
						}}
					>
						<Flag style={{ width: 22, borderRadius: 3, flexShrink: 0 }} />
						<Typography variant="body2" fontWeight={code === current.code ? 600 : 400}>
							{label}
						</Typography>
					</MenuItem>
				))}
			</Menu>
		</>
	);
}